import {
  appTypeKey,
  codeKey,
  deviceInfoMap,
  sChannel,
  sPkg,
  tokenKey,
  uuIdKey,
  version,
  youtubeOutPkgTypeKey,
  authCodeKeyYoutube,
  isReferralEarnApp
} from '@/constants'
import {
  createRequest,
  addEncryInterceptors,
  addDuplicateRequestInterceptor,
  addEspecialCodeReportInterceptor
} from 'web-utils/request'
import { isInNativeApp, deviceInfo, deviceInfoByWeb } from 'web-utils/device'
import { queryURLParams } from 'web-utils/url'
import { lang } from '@/locals'
import Cookies from 'js-cookie'
import { dealLogin, getAppType, fieldSeHandler, clearGuestLogin, isRealTgEnv } from '@/utils'

const env = import.meta.env.MODE
const instance = createRequest({
  baseURL: import.meta.env.VITE_API_URL
})
// 本地模拟原生开发环境, 不需要可以设置为false
const monitorNative = false
const devMonitorNative = env == 'dev' && monitorNative
const refreshFun = async () => {
  // 刷新之前清空 code, token
  clearGuestLogin()
  const token = queryURLParams('token') || ''
  let params = {
    loginType: 'GUEST',
    appVersion: version,
    authCode: token
  }
  if (isRealTgEnv()) {
    const { id } = window?.Telegram?.WebApp?.initDataUnsafe?.user || {}
    params.thirdUserId = id
  } else {
    params.webUuid = localStorage.getItem(uuIdKey)
  }
  const res = await instance.post('/user/user/login', params)
  if (res.code == 0) {
    if (token) {
      localStorage.setItem(authCodeKeyYoutube, token)
    }
    const realPkgType = res.data.user.pkgType
    if (realPkgType) {
      localStorage.setItem(youtubeOutPkgTypeKey, realPkgType)
    }
    dealLogin(res.data)
  } else {
    // 刷新token失败一定要抛错误，防止工具类里面把该业务请求进行了无限的重试
    throw new Error(res.msg)
  }
}
addDuplicateRequestInterceptor(instance)
addEspecialCodeReportInterceptor(instance)
// 请求拦截器执行顺序是反方向的，先添加的后执行
addEncryInterceptors(instance, env, env != 'dev' && env != 'test', true, {
  isRefreshToken: true,
  refreshFun
})
instance.interceptors.request.use((config) => {
  let info = {
    appType: getAppType(),
    appVersion: version,
    code: localStorage.getItem(codeKey) || '',
    token: localStorage.getItem(tokenKey) || '',
    s_pkg: sPkg,
    s_channel: sChannel,
    language: lang,
    os: deviceInfoMap[deviceInfoByWeb().os],
    href: window.location.href,
    webUuid: localStorage.getItem(uuIdKey) || ''
  }
  if (isRealTgEnv()) {
    const { id } = window?.Telegram?.WebApp?.initDataUnsafe?.user || {}
    info.thirdUserId = String(id)
  }
  const isModifyAppType = !!window.TaurusApp?.showPwaType && window.TaurusApp?.showPwaType()
  if ((isInNativeApp() && !isModifyAppType) || devMonitorNative) {
    const {
      token,
      code,
      appType,
      appVersion,
      lang: deviceLang,
      pkg,
      channel,
      gaid,
      aid,
      pkgType
    } = deviceInfo()
    info = {
      ...info,
      appType: Cookies.get('appType') || appType,
      token: Cookies.get(tokenKey) || token || localStorage.getItem(tokenKey),
      code: Cookies.get('code') || code || localStorage.getItem(codeKey),
      language: deviceLang || Cookies.get('language') || lang,
      appVersion: Cookies.get('appVersion') || appVersion,
      s_pkg: Cookies.get('pkg') || pkg,
      s_channel: Cookies.get('channel') || channel,
      s_gaid: Cookies.get('gaid') || gaid,
      s_android_id: Cookies.get('aid') || aid,
      pkgType: pkgType || Cookies.get('pkgType') || 'TAURUS'
    }
  }
  if (isReferralEarnApp) {
    info = { ...info, pkgType: 'REFERRAL_EARN' }
  }
  if (window.location.href.includes('/devTransfer')) {
    const gaid = queryURLParams('gaid')
    info = {
      ...info,
      s_gaid: gaid?.includes('{') || gaid?.includes('gaid') || gaid?.includes('}') ? '' : gaid
    }
  }
  sessionStorage.setItem(appTypeKey, info.appType)
  // 如果是out落地页应用并且是登录接口并且pkgType不为空，则pkgType取链接里面带的
  const urlPkgType = queryURLParams('pkgType')
  const isOutApp = import.meta.env.VITE_APP_TYPE == 'out'
  const isLoginRequest = config.url?.includes('/user/user/login')
  if (isOutApp && isLoginRequest && !!urlPkgType) {
    info.pkgType = urlPkgType
  } else {
    const cachePkgType = localStorage.getItem(youtubeOutPkgTypeKey)
    if (cachePkgType) {
      info.pkgType = cachePkgType
    }
  }
  config.headers = {
    ...config.headers,
    'X-Info': JSON.stringify(info)
  }
  return config
})
instance.interceptors.response.use(
  (res) => {
    const { code } = res || {}
    if (code === 0) {
      return fieldSeHandler(res)
    }
    return res
  },
  (err) => {
    return err?.response?.data || {}
  }
)
export default instance
